import React from "react";
import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from "./ui/accordion";

const faqs = [
  {
    q: "Como funciona a transferência de uma carta contemplada?",
    a: "A transferência é formalizada em cartório junto à administradora do consórcio. Após a análise documental (identidade, comprovantes e ficha cadastral), assinamos o termo de cessão de direitos com reconhecimento de firma e a administradora oficializa a troca de titularidade. Todo o processo é registrado, com respaldo jurídico e conformidade regulatória (Lei 11.795/08).",
  },
  {
    q: "É seguro comprar uma carta contemplada?",
    a: "Sim — quando a operação é conduzida por especialistas. Na ASHIR GROUP, cada carta passa por due diligence completa (jurídica, fiscal e cadastral), a transferência é registrada em cartório e a administradora — autorizada e fiscalizada pelo Banco Central — chancela a mudança de titular. Você recebe todos os documentos originais e o contrato antes de qualquer pagamento.",
  },
  {
    q: "Qual o prazo para liberação do crédito?",
    a: "Após aprovação da análise documental e assinatura do contrato em cartório, a administradora libera o crédito normalmente entre 7 e 15 dias úteis. Casos empresariais estruturados podem ser acelerados. Todo o cronograma é acordado por escrito no início da operação — sem surpresas.",
  },
  {
    q: "O que é uma carta de consórcio contemplada?",
    a: "É uma carta de crédito de consórcio cujo participante já foi sorteado ou lance vencedor — ou seja, o crédito está liberado e pode ser transferido formalmente a um novo titular para uso imediato, com respaldo da administradora.",
  },
  {
    q: "A ASHIR GROUP atende em São José dos Campos e no Vale do Paraíba?",
    a: "Sim. Somos referência em São José dos Campos e atendemos todo o Vale do Paraíba (Taubaté, Jacareí, Caçapava, Pindamonhangaba, Guaratinguetá), além de São Paulo Capital e todo o Brasil, com atendimento consultivo presencial ou remoto.",
  },
  {
    q: "Quais valores estão disponíveis?",
    a: "Trabalhamos com cartas contempladas de R$ 85 mil a mais de R$ 1,2 milhão, tanto para veículos quanto para imóveis. A análise é personalizada, com apresentação das melhores opções para o seu projeto.",
  },
  {
    q: "Quais as vantagens em relação ao crédito bancário tradicional?",
    a: "Custo financeiro significativamente menor (economia média de 30% a 60% em juros — simule na nossa Calculadora), ausência de juros abusivos, parcelas planejáveis, sem necessidade de comprovação rigorosa de score bancário tradicional e flexibilidade para empresas e pessoas físicas.",
  },
];

export default function FAQ() {
  return (
    <section
      id="faq"
      data-testid="faq-section"
      className="relative bg-[#05070D] py-24 md:py-36"
    >
      <div className="max-w-5xl mx-auto px-6 md:px-12">
        <div className="text-center mb-16">
          <div className="flex items-center justify-center gap-4 mb-6">
            <div className="gold-line" />
            <span className="overline">Perguntas Frequentes</span>
            <div className="gold-line rotate-180" />
          </div>
          <h2 className="font-serif-ag text-white text-4xl md:text-5xl lg:text-[3.5rem] font-light leading-[1.05] tracking-[-0.015em]">
            Tudo o que você precisa{" "}
            <span className="text-[#D4AF37] italic">saber</span>.
          </h2>
        </div>

        <Accordion type="single" collapsible className="space-y-3">
          {faqs.map((f, i) => (
            <AccordionItem
              key={i}
              value={`q-${i}`}
              data-testid={`faq-item-${i}`}
              className="border border-white/5 hover:border-[#D4AF37]/30 transition-colors data-[state=open]:border-[#D4AF37]/50 bg-[#0B101A] px-6 md:px-8"
            >
              <AccordionTrigger
                data-testid={`faq-trigger-${i}`}
                className="text-left font-serif-ag text-white text-lg md:text-xl py-6 hover:no-underline hover:text-[#D4AF37] data-[state=open]:text-[#D4AF37]"
              >
                {f.q}
              </AccordionTrigger>
              <AccordionContent
                data-testid={`faq-content-${i}`}
                className="text-[#A3ABB8] text-base font-light leading-relaxed pb-6"
              >
                {f.a}
              </AccordionContent>
            </AccordionItem>
          ))}
        </Accordion>
      </div>
    </section>
  );
}
